<script>
export default {

    data() {
        return {
            newProfilePicture: {},
            paypal_email: '',
            password: '',
            new_password: '', 
            new_password_confirmed: '',
            email: '',
            minimal_payment_threshold: null,
            receive_daily_letter: false,
        };
    },

    metaInfo: {
        title: 'Settings',
    },

    async mounted() {
        const profileData = await window.axios.get('/api/user/profile');
        this.paypal_email = profileData.data.paypal_email;
        this.minimal_payment_threshold = profileData.data.minimal_payment_threshold;
        this.receive_daily_letter = profileData.data.receive_daily_letter;
        this.email = profileData.data.email;
    },

    methods: {
        setImage(event) {
            [this.newProfilePicture.image] = event.target.files;
        },

        async postImage() {
            this.isLoading = true;

            try {
                const formData = new FormData();

                formData.append('image', this.newProfilePicture.image)

                const response = await window.axios.post(
                    '/api/user/image',
                    formData,
                    { headers: { 'Content-Type': 'multipart/form-data' } },
                );

                Vue.toasted.show('Profile image updated', { duration: 4000, icon: 'check' });

                // Start loading profile data, as some data may be necessary for the navbar
                this.$store.dispatch('loadProfileData');
            } catch (error) {
                console.log(error);
            } finally {
                this.isLoading = false;
            }
        },

        async saveProfile() {
            try {
                const data = { 
                    paypal_email: this.paypal_email,
                    minimal_payment_threshold: this.minimal_payment_threshold,
                    receive_daily_letter: this.receive_daily_letter,
                };
                
                if (this.new_password !== '') {
                    data.password = this.password;
                    data.new_password = this.new_password;
                    data.new_password_confirmation = this.new_password_confirmed;
                }
                await window.axios.patch('/api/user/settings/', data);

                Vue.toasted.show(
                    'Settings successfully changed', 
                    { duration: 4000, icon: 'success' },
                );
            } catch (error) {
                for (let err in error.response.data.errors) {
                    Vue.toasted.show(
                        error.response.data.errors[err], 
                        { duration: 4000, icon: 'error' },
                    );
                }
            }
        }
    },

    
}
</script>

<template lang='pug' src='./template/Settings.pug'></template>
<style lang='stylus' src='./styles/Settings.styl' scoped></style>